import request from '@/utils/request'

export function selectPanel(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/panel/selectPanel?access=${data}`,
        method: 'post',
       // data,
    })
}

export function upDatePanel(data) {
    return request({
        url: `api/serviceCenter/panel/upDatePanel`,
        method: 'post',
        data,
    })
}
export function bathDeleteFile(data) {
    return request({
        url: `api/serviceCenter/panel/bathDeleteFile`,
        method: 'post',
        data,
    })
}

export function addPanel(data) {
    return request({
        url: `api/serviceCenter/panel/addPanel`,
        method: 'post',
        data,
    })
}

export function selectPanelName(data) {
    return request({
        url: `api/serviceCenter/setPanel/selectPanelName?access=${data}`,
        method: 'post',
    })
}
